<template>
  <UIDialog
    :is-open
    :z-index
    title="Assign tag"
    @close="handleClose"
  >
    <TagsListDropdown v-model="selectedTag" :disabled="loading" />
    <UIButtonsGroup>
      <UIButtonClose @click="handleClose" />
      <UIButtonSave
        label="Add"
        v-bind="{ loading }"
        :disabled="!selectedTag"
        @click="handleClickAdd"
      />
    </UIButtonsGroup>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import {
  LinkedDataTransaction,
  LinkedDataTransactionUpdate,
  ModalClass
} from '@types'

import { useLinkedDataTransactionsTagsStore } from '@/store/linkedData/transactionsTags'

import { UIDialog } from '@ui/modals'
import { UIButtonClose, UIButtonSave, UIButtonsGroup } from '@ui/buttons'

import TagsListDropdown from './TagsListDropdown.vue'

type Props = {
  modal: ModalClass<any>
  items: LinkedDataTransaction[]
  ids: string[]
}

type Emits = {
  process: [data: LinkedDataTransactionUpdate[], callback: () => void]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const linkedDataTransactionsTagsStore = useLinkedDataTransactionsTagsStore()

const loading = ref(false)

const selectedTag = ref<string>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}

const handleClickAdd = async () => {
  loading.value = true
  const tag = linkedDataTransactionsTagsStore.getList.find(
    item => item.id === selectedTag.value,
  )
  if (!tag) return
  const result = props.ids.reduce((acc, id) => {
    const transaction = props.items.find(item => item.id === id)
    const existingTags = transaction?.tags || []
    if (
      selectedTag.value &&
      existingTags?.every(tag => tag.id !== selectedTag.value)
    ) {
      const tags = [...existingTags, tag].map(item => `${item.id}`)
      acc.push({ id, tags })
    }
    return acc
  }, [] as LinkedDataTransactionUpdate[])
  if (!result) {
    loading.value = false
    return
  }
  emit('process', result, () => {
    loading.value = false
  })
  handleClose()
}
</script>
